import { useQuery } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'
import { ULTIMOS_MODIFICADOS_QUERY } from '../data/ultimo-modificados-query'
import { UltimosModificadosQueryGqlQuery } from '@/core/types/graphql'

export const useArquivosRecentes = () => {
  const { data: dataArquivosRecentes, isLoading: loadingArquivosRecentes } =
    useQuery({
      queryKey: ['ultimosModificados'],
      queryFn: async () =>
        await request<UltimosModificadosQueryGqlQuery>(
          ULTIMOS_MODIFICADOS_QUERY
        )
    })

  return {
    dataArquivosRecentes,
    loadingArquivosRecentes
  }
}
